import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from '../index.less';

const cx = classNames.bind(styles);

const defaultProps = {
  companyName: '-',
  createdOn: '-'
};
const propTypes = {
  name: PropTypes.string.isRequired,
  companyName: PropTypes.string,
  createdOn: PropTypes.string
};

const UserInfo = ({ name, companyName, createdOn }) => (
  <div className={cx('baseInfo')}>
    <p>{name}</p>
    <p>{companyName}</p>
  </div>
);

UserInfo.defaultProps = defaultProps;
UserInfo.propTypes = propTypes;
export default UserInfo;



// WEBPACK FOOTER //
// ./src/views/RealTimeReport/components/UserInfo.jsx